import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-compare-list',
    templateUrl: './compare-list.component.html',
    styleUrls: ['./compare-list.component.scss'],
    standalone: false
})
export class CompareListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
